type NestedKeyOf<ObjectType extends object> = {
    [Key in keyof ObjectType & string]: ObjectType[Key] extends object
        ? `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}`
        : `${Key}`;
}[keyof ObjectType & string];

type PathValue<T, P extends string> = P extends `${infer Key}.${infer Rest}`
    ? Key extends keyof T
        ? PathValue<T[Key], Rest>
        : never
    : P extends keyof T
      ? T[P]
      : never;

export function getProperty<T extends object, P extends NestedKeyOf<T>>(
    path: P,
    object: T
): PathValue<T, P> {
    return path
        .split(".")
        .reduce<
            Record<string, unknown>
        >((o, i) => o[i] as Record<string, unknown>, object as Record<string, unknown>) as PathValue<
        T,
        P
    >;
}
